import * as e from "react";
const r = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.37 1.837a1.54 1.54 0 00-2.74 0L1.165 18.768A1.54 1.54 0 002.535 21h16.93a1.539 1.539 0 001.37-2.232L12.37 1.838z",
      fill: "#E63900",
      stroke: "#E63900",
      strokeWidth: 1.385,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ e.createElement("path", { d: "M11 18.383a1 1 0 100-2 1 1 0 000 2z", fill: "#fff" }),
  /* @__PURE__ */ e.createElement("rect", { x: 10, y: 7, width: 2, height: 8, rx: 1, fill: "#fff" })
), l = r;
export {
  l as default
};
